import { AccountSummary } from './AccountSummary';

class AccountDetails {
  accountId: number;
  accountNumber: string;
  alias: string;
  productDescription: string;
  created: string;
  lastUpdated: string;
  accountRelationDescription: string;
  beneficiary: string;
  description: string;
  iban: string;
  currentBalance: number;
  availableBalance: number;
  blockedAmount: number;
  withdrawableBalance: number;
  overdraftLimit: number;
  unclearAmount: number;
  accountStatus: string;
  currencyId: number;
  currencyName: string;
  bic: string;
  organizationName: string;
  isEnabled: boolean;
  summary: AccountSummary;

  constructor(
    accountId: number,
    accountNumber: string,
    alias: string,
    productDescription: string,
    created: string,
    lastUpdated: string,
    accountRelationDescription: string,
    beneficiary: string,
    description: string,
    iban: string,
    currentBalance: number,
    availableBalance: number,
    blockedAmount: number,
    withdrawableBalance: number,
    overdraftLimit: number,
    unclearAmount: number,
    accountStatus: string,
    currencyId: number,
    currencyName: string,
    bic: string,
    organizationName: string,
    isEnabled: boolean,
  ) {
    this.accountId = accountId;
    this.accountNumber = accountNumber;
    this.alias = alias;
    this.productDescription = productDescription;
    this.created = created;
    this.lastUpdated = lastUpdated;
    this.accountRelationDescription = accountRelationDescription;
    this.beneficiary = beneficiary;
    this.description = description;
    this.iban = iban;
    this.currentBalance = currentBalance;
    this.availableBalance = availableBalance;
    this.blockedAmount = blockedAmount;
    this.withdrawableBalance = withdrawableBalance;
    this.overdraftLimit = overdraftLimit;
    this.unclearAmount = unclearAmount;
    this.accountStatus = accountStatus;
    this.currencyId = currencyId;
    this.currencyName = currencyName;
    this.bic = bic;
    this.organizationName = organizationName;
    this.isEnabled = isEnabled;
    this.summary = new AccountSummary(currentBalance, availableBalance, unclearAmount, blockedAmount, currencyName);
  }
}

export { AccountDetails };
